import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

export interface ImageBanner {
  id: number;
  title: string;
  description?: string;
  imageUrl: string;
  isDeleted: boolean;
  isVisible: boolean;
  sort_order: number;
  created_at: string;
  updated_at: string;
}

export interface ImageBannerResponse {
  success: boolean;
  data: ImageBanner[];
  message?: string;
}

class ImageBannerService {
  private baseURL = `${API_BASE_URL}/mock-image-banner`; // Using mock data for testing

  // Get all image banners
  async getImageBanners(): Promise<ImageBanner[]> {
    try {
      const response = await axios.get<ImageBannerResponse>(this.baseURL);
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch image banners');
      }
    } catch (error) {
      console.error('Error fetching image banners:', error);
      throw error;
    }
  }

  // Get single image banner by ID
  async getImageBannerById(id: number): Promise<ImageBanner> {
    try {
      const response = await axios.get<{ success: boolean; data: ImageBanner; message?: string }>(`${this.baseURL}/${id}`);
      
      if (response.data.success) {
        return response.data.data;
      } else {
        throw new Error(response.data.message || 'Failed to fetch image banner');
      }
    } catch (error) {
      console.error('Error fetching image banner by ID:', error);
      throw error;
    }
  }
}

export default new ImageBannerService();
